// Pure helpers for the Intel feeds page: filters, the vendor strip, and the "affects you" grouping.
export const SEV = { critical: '#ef4444', high: '#f97316', medium: '#f59e0b', low: '#60a5fa', info: '#64748b' };
export const FILTERS = [
  { id: 'all', label: 'All', test: () => true },
  { id: 'month', label: 'This month', test: (r, now) => r.published_at && now - new Date(r.published_at) <= 30 * 86400000 },
  { id: 'critical', label: 'Critical', test: (r) => r.severity === 'critical' },
  { id: 'mine', label: 'You have this', test: (r) => r.mine }
];

// Marks each entry that matches one of the user's open findings.
export const withMine = (rows, correlations) => {
  const mine = new Set(correlations.map((c) => c.cve_id));
  return rows.map((r) => ({ ...r, mine: Boolean(r.cve_id) && mine.has(String(r.cve_id).toUpperCase()) }));
};

export const search = (rows, q) => {
  const needle = String(q || '').trim().toLowerCase();
  return needle ? rows.filter((r) => `${r.cve_id} ${r.vendor} ${r.product} ${r.summary} ${r.title}`.toLowerCase().includes(needle)) : rows;
};

export function vendors(rows, top = 6) {
  const by = {};
  rows.forEach((r) => {
    const v = (r.vendor || '').trim();
    if (!v) return;
    const e = (by[v] ||= { vendor: v, n: 0, latest: r });
    e.n += 1;
    if (new Date(r.published_at || 0) > new Date(e.latest.published_at || 0)) e.latest = r;
  });
  return Object.values(by).sort((a, b) => b.n - a.n || a.vendor.localeCompare(b.vendor)).slice(0, top);
}

// One line per finding, however many feed entries matched it.
export function affected(correlations) {
  const seen = new Map();
  correlations.forEach((c) => { if (!seen.has(c.finding_id)) seen.set(c.finding_id, c); });
  return [...seen.values()].sort((a, b) => Number(b.intel_exploited) - Number(a.intel_exploited));
}

export const summary = (rows, now = new Date()) => ({
  shown: rows.length,
  exploited: rows.filter((r) => r.exploited).length,
  month: rows.filter((r) => r.published_at && now - new Date(r.published_at) <= 30 * 86400000).length,
  newest: rows.map((r) => r.published_at).filter(Boolean).sort().pop() || null
});
